import {z as zod} from "zod";

export type OttopilotAnnouncementsWorkspaceCapabilityConfiguration = Record<string, never>;

export const ottopilotAnnouncementsWorkspaceCapabilityConfigurationValidator: zod.ZodType<OttopilotAnnouncementsWorkspaceCapabilityConfiguration> = zod.strictObject({});
